/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateMarkupResponse {
    getFixupPrototypeFunction() { return UpdateMarkupResponse.fixupPrototype; }

    static newInstance(model: Partial<UpdateMarkupResponse>): UpdateMarkupResponse {
        let obj = Object.assign(new UpdateMarkupResponse(), model);
        UpdateMarkupResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateMarkupResponse>): UpdateMarkupResponse {
        if (!model) return null;
        return UpdateMarkupResponse.newInstance(<UpdateMarkupResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateMarkupResponse) {
        if (!obj) return;

        models.UpdateMarkupResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateMarkupResponse): boolean {
        Object.setPrototypeOf(obj, UpdateMarkupResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Updated Rule name
     */
    name: string;

}
